import React, { useEffect, useState } from "react";
import { Link, useNavigate } from "react-router-dom";
import "./NavbarStyle.css";

import {
  BackArrowIcon2,
  New_ScrollX2025,
  NotificationsIcon,
  SX_dashboard_Help_icon,
} from "../../../assets/icons";

import { useDispatch, useSelector } from "react-redux";
import { getDefaultSettings } from "../../../Redux/actions/defaultSettingsActions";

// ========================================================================================
// Project Layouts
import { toast, ToastContainer } from "react-toastify";
import "react-toastify/dist/ReactToastify.css";

import {
  addNotifications,
  deleteNotifications,
  getNotification,
  updateNotification,
} from "../../../Redux/actions/commonActtion";

import { DropdownForNotiFy } from "../../../Components";
import Setting from "../../Setting/Setting";

const Navbar = ({
  isProjectOpen,
  renderOpen,
  setRenderOpen,
}) => {
  // console.log("isProjectOpen in Navbar:", isProjectOpen); // Check console
  const userInfo = JSON.parse(localStorage.getItem("user"));
  const navigate = useNavigate();
  const dispatch = useDispatch();
  const [isSettingOpen, setIsSettingOpen] = useState(false);  // For User Profile Settings 
  const [isOptionsVisible, setIsOptionsVisible] = useState(false);  // For Notification Settings 
  const project = useSelector((state) => state.project);

  const notifications = useSelector(
    (state) => state.commonReducer.notifications
  );
  const notificationsWithReadStatus = useSelector(
    (state) => state.commonReducer.notificationsWithReadStatus
  );
  let notificationsLentgh = notificationsWithReadStatus
    ? notificationsWithReadStatus.length
    : 0;

  useEffect(() => {
    fetchProjectSettings();
    dispatch(getNotification());
  }, []);

  const fetchProjectSettings = () => {
    dispatch(getDefaultSettings());
  };

  // Notification
  const getAllNotification = async () => {
    if (notificationsLentgh > 0) {
      await dispatch(updateNotification()).then(() => {
        notificationsLentgh = notificationsWithReadStatus.length;
      });
    }
    setIsOptionsVisible(true);
    await dispatch(getNotification());
  };
  const fetchData = async (arg) => {};
  const handleDeleteNotification = async (id) => {
    await dispatch(deleteNotifications({ notification_id: id }));
  };

  //  Get Profile Icon Letter
  const getUserInitials = () => {
    // console.log("userInfo:", userInfo); // Debugging output

    const firstName = userInfo?.firstName?.trim() || "";
    // const lastName = userInfo?.lastName?.trim() || "";

    if (firstName) {
      return `${firstName.charAt(0).toUpperCase()}`;
    }
    return "U"; // Default initial if no name is available
  };

  const getBackgroundColor = () => {
    const initials = getUserInitials(); // Get initials
    const firstLetter = initials.charAt(0); // Extract first letter

    // console.log("First Letter for Color:", firstLetter); // Debugging

    const colors = {
      A: "#413CAA",
      B: "#413CAA",
      C: "#413CAA",
      D: "#413CAA",
      E: "#413CAA",
      F: "#413CAA",
      G: "#413CAA",
      H: "#413CAA",
      I: "#413CAA",
      J: "#413CAA",
      K: "#413CAA",
      L: "#413CAA",
      M: "#413CAA",
      N: "#413CAA",
      O: "#413CAA",
      P: "#413CAA",
      Q: "#413CAA",
      R: "#413CAA",
      S: "#413CAA",
      T: "#413CAA",
      U: "#413CAA",
      V: "#413CAA",
      W: "#413CAA",
      X: "#413CAA",
      Y: "#413CAA",
      Z: "#413CAA",
    };

    return colors[firstLetter] || "#413CAA"; // Default color if not found
  };

  //   Toast Notification
  const CloseButton = ({ closeToast }) => (
    <i className="material-icons w-7 flex justify-center cursor-pointer not-italic" onClick={closeToast}>✖</i>
  );

  // Navigate to Back
  const navigateHandler = () => {
    if (renderOpen) {
      setRenderOpen(false);
    } else {
      navigate("/dashboard");
    }
  };

  return (
    <>
      <nav id="navbar_1" className="w-full Pro_navbarDash h-[64px] flex flex-wrap items-center justify-between text-slate-200 focus:text-sly-700 drop-shadow-2xl bg-[#171717]">
        <ToastContainer closeButton={CloseButton} />

        <div className="w-full h-full flex flex-wrap items-center justify-between pl-[1%] pr-[2%]">
          <div className="w-[15%] flex justify-between items-center">
            <button className={isProjectOpen ? "hidden" : "w-[15%] flex items-center"} onClick={navigateHandler}>
              <img className="ml-2 w-[11px] cursor-pointer" src={BackArrowIcon2} alt=""/>
            </button>
            <div className="w-[85%] fixed left-[60px] flex items-center">
              <img className="w-[35px] " src={New_ScrollX2025} />
              <span className="ml-[10px] Syne text-xl font-light tracking-wide ">ScrollX.io</span>
            </div>
          </div>

          <div className="w-[52%] flex justify-center items-center">
            <h1 className="manrope-600 text-[15px] text-white font-light">{isProjectOpen ? "Dashboard" : project?.title?.toUpperCase()}</h1>
          </div>

          <div className="w-[30%] flex justify-end items-center">
           
            {/* <div><img className="w-[30px] mr-[20px]" src={SX_dashboard_Help_icon} alt="" /></div> */}

            <div className="flex items-center">
              {isProjectOpen ? (
                <div className="mr-[20px] manrope-600 text-[15px]  text-white">
                  <Link to="/dashboard/myrenders"><h2>My Renders </h2></Link>
                </div>
              ) : (
                <div className="flex  mx-3  px-1 notification ">
                  <button><img className="pro_navabr_Notifications opacity-75" src={NotificationsIcon} onClick={getAllNotification} alt=""/></button>
                  {notificationsLentgh > 0 && (<button class="badge">{notificationsLentgh}</button>)}
                </div>
              )}
              
              <div className="flex m-auto">
                <button className="w-[35px] h-[35px] rounded-full" onClick={() => setIsSettingOpen(true)} style={{ backgroundColor: getBackgroundColor() }}>
                  <div className="flex justify-center items-center text-white text-xl manrope-600 w-[35px] h-[35px] rounded-full ">
                    <span className="manrope-600 text-white text-xl text-center ">{getUserInitials()}</span>
                  </div>
                </button>
              </div>
            </div>
          </div>
        </div>
      </nav>

      <Setting
        isSettingOpen={isSettingOpen}
        setIsSettingOpen={setIsSettingOpen}
      />
      <DropdownForNotiFy
        isOptionsVisible={isOptionsVisible}
        setIsOptionsVisible={setIsOptionsVisible}
        options={notifications}
        notificationsLentgh={notificationsLentgh}
        fetchMoreData={fetchData}
        handleDeleteNotification={handleDeleteNotification}
      />
    </>
  );
};

export default Navbar;